<template>
    <edit-resource
        :title="title"
        :form="form"
        @close="$emit('close')"
        @submit="saveImages">
        <div class="w-600">
            <file-upload
                :multiple="multiple"
                class="w-full rounded shadow-md"
                icon-location="corner"
                v-model="form.qids">
            </file-upload>
        </div>
    </edit-resource>
</template>

<script>
import EditResource from './EditResource.vue';
import Input from '../forms/Input.vue';
import Translatable from '../forms/Translatable.vue';
import Image from '../../models/Image';
import * as images from '../../services/ImageService';
import _mapValues from 'lodash/mapValues';
import _isEqual from 'lodash/isEqual';
import Form from '../../etc/forms/Form';
import { normalizeJson } from '../../../shared/helpers';
import FileUpload from '../forms/FileUpload.vue';
import {useRepo} from 'pinia-orm';

function getFields () {
    return [
        { name: 'qids', value: [] },
    ];
}

export default {
    components: {
        'edit-resource': EditResource,
        'simple-input': Input,
        'translatable': Translatable,
        'file-upload': FileUpload,
    },
    props: {
        image: Object,
        multiple: {
            type: Boolean,
            default: false,
        }
    },
    data: function () {
        return {
            form: this.generateForm(),
        }
    },
    computed: {
        title () {
            return this.$t(this.image ? 'general.edit_subject' : 'general.add_subject', { subject: this.multiple ? this.$t('site_editor.image.plural') : this.$t('site_editor.image.single') });
        },
    },
    methods: {
        generateForm () {
            let fields = getFields();
            if (this.image) {
                fields.forEach((field, index) => {
                    if (this.image.hasOwnProperty(field.name)) {
                        fields[index].value = JSON.parse(JSON.stringify(this.image[field.name]));
                    }
                });
            }
            return new Form(fields);
        },
        async saveImages () {
            this.form.submitting = true;

            let promise;

            if (typeof this.form.data.qids === 'number') {
                promise = images.store({
                    data: {
                        type: 'images',
                        attributes: {photo_path_queued_id: this.form.data.qids},
                    }
                });
            } else {
                promise = images.storeBulk({
                    data: Object.values(this.form.data.qids).map(id => ({
                        type: 'images',
                        attributes: {photo_path_queued_id: id},
                    }))
                });
            }

            promise.catch(error => {
                this._handleError(error);
                throw error;
            }).then(result => {
                if (!Array.isArray(result)) {
                    result = [result];
                }

                result.forEach(item => {
                    this.$emit('created', item.id);
                    return useRepo(Image).save(normalizeJson(item));
                })
            }).finally(() => {
                this.form.submitting = false;
                this.$emit('close');
            });
        },
    }
}
</script>
